import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19f86991"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-4 py-lg-5 col-xl-6" }
const _hoisted_2 = { class: "title fs-5 fs-lg-4 text-center mb-5" }
const _hoisted_3 = { class: "mx-sm-5 mx-2" }
const _hoisted_4 = {
  class: "mb-3 fw-bold",
  style: {"margin-left":"-6px"}
}
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = { class: "d-flex justify-content-center" }

import Button from '@/components/button/index.vue'
import { useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const redirectLogin = () => {
  router.push('/community/users/login')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)(`SC50title`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)(`SC51heading1`)), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translate)(`SC51heading2`)), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(Button, {
          title: _unref(translate)('login'),
          className: 'fw-bold',
          type: 'secondary',
          onClick: redirectLogin
        }, null, 8, ["title"])
      ])
    ])
  ]))
}
}

})